import Task, { Status } from "model/data/task";

export default function checklistCompleted(tasks: Task[]): boolean {
  const status = [Status.COMPLETED, Status.NO_APPLICABLE];
  const uncompletedTasks = tasks.filter((task) => !status.includes(task.status));
  return uncompletedTasks.length === 0;
}